import { Button } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ShowPhone.css';
import { parsePhoneNumber } from '../../utils/strings';

interface IShowPhoneProps {
  name?: string | null;
  withNote: boolean;
  phones: string[];
  trackClick(): void;
}

export const ShowPhone: React.FC<IShowPhoneProps> = ({ name, withNote, phones, trackClick }) => {
  const [phoneVisible, setPhoneVisible] = React.useState(false);

  const handleClickPhone = React.useCallback(() => {
    setPhoneVisible(true);

    trackClick();
  }, [trackClick]);

  return (
    <div className={styles['container']}>
      {phoneVisible ? (
        <div>
          <p className={styles['name']}>{name}</p>
          {phones.map(phone => (
            <div key={phone} className={styles['phone']}>
              {parsePhoneNumber(phone)}
            </div>
          ))}
          {withNote && <p className={styles['note']}>Сообщите владельцу, что вы нашли это объявление на ЦИАН.</p>}
        </div>
      ) : (
        <Button theme="fill_primary" size="XS" onClick={handleClickPhone}>
          Показать телефон
        </Button>
      )}
    </div>
  );
};
